import { makeStyles, Hidden } from "@material-ui/core";
import React, { useState } from "react";
import { Sidebar, Topbar, Footer } from "./components";

const useStyles = makeStyles((theme) => ({}));

function Main(props) {
  const { children,cartCounter } = props;
  console.log(props,"main")
  const classes = useStyles();
  const [openSidebar, setOpenSidebar] = useState(false);
  const handleSidebarOpen = () => {
    setOpenSidebar(true);
  };
  const handleSidebarClose = () => {
    setOpenSidebar(false);
  };
  return (
    <div>
      <Topbar openSidebar={handleSidebarOpen} cartCounter={props.cartCounter} />
      <Hidden only={["lg", "xl"]}>
        <Sidebar
          open={openSidebar}
          onClose={handleSidebarClose}
          variant="temporary"
        />
      </Hidden>
      <div className={classes.content}>{children}</div>
    </div>
  );
}

export default Main;
